<div *ngIf="!acknowledged && note && user && showAcknowledgeButton">
	<button pButton class="p-button-sm"
			label="Acknowledge" [disabled]="loading" (click)="acknowledge()">
	</button>
</div>

<ng-container *ngFor="let ack of acknowledgements">
	<div *ngIf="belongsToMe(ack) || showAll">
		{{(showTime) ? (ack.updated | date: 'MM/dd/yyyy HH:mm') + ' by ' : ''}}
		{{ack.createdBy.firstName}} {{ack.createdBy.lastName}}
	</div>
</ng-container>

<div *ngIf="displayShowAllButton && count > 0">
	<button pButton class="p-button-link p-p-0"
			[label]="'Show ' + (!showAll ? (count + ' more') : 'less')" (click)="showAll = !showAll">
	</button>
</div>